import Router, { useRouter } from "next/router";
import Slider from "rc-slider";
import React from "react";
import { useSelector } from "react-redux";

import { AppState } from "shared/data/reducers";
import { SearchQuery } from "shared/data/reducers/types/storage";

import PriceFormatter from "@components/Formatters/PriceFormatter";
import FormattedMessage from "@components/UI/FormattedMessage";

import { ROUTES } from "@shared/constants";

import { State } from "./types";

const { createSliderWithTooltip } = Slider;
const Range = createSliderWithTooltip(Slider.Range);

type Props = {
  query: SearchQuery;
  priceFilter: State["priceFilter"];
  setState: React.Dispatch<React.SetStateAction<State>>;
};

const FilterBox5 = ({ query, priceFilter, setState }: Props) => {
  const {
    highestPrice,
    lowestPrice,
    currency,
    highestAlternativeCurrencyPrice,
    lowestAlternativeCurrencyPrice,
  } = useSelector((appState: AppState) => ({
    highestPrice: appState.search.highestPrice,
    lowestPrice: appState.search.lowestPrice,
    highestAlternativeCurrencyPrice:
      appState.search.highestAlternativeCurrencyPrice,
    lowestAlternativeCurrencyPrice:
      appState.search.lowestAlternativeCurrencyPrice,
    currency: appState.search.currency,
  }));
  const router = useRouter();

  const setPriceFilter = (prices: number[]) => {
    setState((state) => ({
      ...state,
      priceFilter: prices,
    }));
  };

  const onAfterChange = (value: [number, number]) => {
    Router.replace(
      {
        pathname: ROUTES.RESULTS,
        query: {
          ...query,
          lowestPrice: value[0],
          highestPrice: value[1],
        },
      },
      undefined,
      { shallow: true, scroll: false }
    );
  };

  return (
    <div className="filters-box">
      <span className="filters-label">
        <FormattedMessage id="Filters.flightTicketPrice" />:
      </span>
      <div className="filters-box-content">
        <div className="filters-range-description">
          <b>
            <FormattedMessage id="Filters.flightTicketPriceTogether" />:{" "}
            <span style={{ float: "right" }}>
              <PriceFormatter
                price={priceFilter[0]}
                customCurrency={router.query.currency || currency}
              />{" "}
              -{" "}
              <PriceFormatter
                price={priceFilter[1]}
                customCurrency={router.query.currency || currency}
              />
            </span>
          </b>
        </div>

        <Range
          onAfterChange={onAfterChange}
          onChange={(e) => {
            setPriceFilter([e[0], e[1]]);
          }}
          min={
            router.query.currency ? lowestAlternativeCurrencyPrice : lowestPrice
          }
          step={1}
          allowCross={false}
          max={
            router.query.currency
              ? highestAlternativeCurrencyPrice
              : highestPrice
          }
          value={priceFilter}
          tipFormatter={(val) => (
            <PriceFormatter
              price={val}
              customCurrency={router.query.currency || currency}
            />
          )}
        />
      </div>
    </div>
  );
};

export default FilterBox5;
